'use client';

var styles = {"container":"SlideModal-module_container__fsD4N","isOpen":"SlideModal-module_isOpen__2hooY","header":"SlideModal-module_header__TIczo","title":"SlideModal-module_title__2wqTw","icon":"SlideModal-module_icon__2OM9w","backdrop":"SlideModal-module_backdrop__2klfi"};

export { styles as default };
//# sourceMappingURL=SlideModal.module.css.js.map
